import { BidResponseDocumentType } from '../../../entities/BidResponseDocument';
import { magellanClient } from '../../../infra/axios';
import type {
  CreateBidResponseRequestDTO,
  CreateBidResponseResponseDTO,
  GetBidResponseByIdRequestDTO,
  GetBidResponseByIdResponseDTO,
  GetBidResponsesResponseDTO,
  UpdateBidResponseRequestDTO,
  UpdateBidResponseResponseDTO,
} from './dto';

export async function getBidResponses(): Promise<GetBidResponsesResponseDTO> {
  const response =
    await magellanClient.get<GetBidResponsesResponseDTO>(`/bidResponses`);

  return response.data;
}

export async function getBidResponseById({
  bidResponseId,
}: GetBidResponseByIdRequestDTO): Promise<GetBidResponseByIdResponseDTO> {
  const response = await magellanClient.get<GetBidResponseByIdResponseDTO>(
    `/bidResponses/${bidResponseId}`,
  );

  return response.data;
}

export async function createBidResponse(payload: CreateBidResponseRequestDTO) {
  const formData = new FormData();

  formData.append('title', payload.title);
  formData.append('responseDeadline', payload.responseDeadline.toISOString());
  formData.append('ownerId', String(payload.ownerId));

  payload.bidResponseFiles.forEach(({ file, type }) => {
    formData.append(
      type || BidResponseDocumentType.UNKNOWN,
      file,
      encodeURIComponent(file.name),
    );
  });

  const response = await magellanClient.post<CreateBidResponseResponseDTO>(
    `/bidResponses`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response.data;
}

export async function updateBidResponse({
  bidResponseId,
  payload,
}: {
  bidResponseId: number;
  payload: UpdateBidResponseRequestDTO;
}) {
  const formData = new FormData();

  if (payload.title) {
    formData.append('title', payload.title);
  }

  if (payload.responseDeadline) {
    formData.append('responseDeadline', payload.responseDeadline.toISOString());
  }

  if (payload.ownerId) {
    formData.append('ownerId', String(payload.ownerId));
  }

  if (payload.files) {
    for (const { file, type } of payload.files) {
      formData.append(
        type || BidResponseDocumentType.UNKNOWN,
        file,
        encodeURIComponent(file.name),
      );
    }
  }

  const response = await magellanClient.put<UpdateBidResponseResponseDTO>(
    `/bidResponses/${bidResponseId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );

  return response.data;
}

export async function deleteBidResponse(bidResponseId: number) {
  await magellanClient.delete(`/bidResponses/${bidResponseId}`);
}
